import React, { useState, useRef } from 'react';
import { titleCase } from '../../base/common/utils';

import Icon from '../../ui/icon';
import BasicDropdown from '../../base/dropdowns/basic-dropdown';

import './create-story-modal.scss';

const channelOptions = [
  'youtube',
  'facebook',
  'instagram',
  'tiktok',
  'site',
  'newsletter',
  'other',
].map(channel => ({
  label: titleCase(channel),
  value: channel,
}));

const StoryModal = ({ action = 'create', story, setShowModal, handleSubmit }) => {
  const headerTxt = action === 'create' ? 'Create a New Post' : 'Edit Post';
  const submitTxt = action === 'create' ? 'Create New Post' : 'Save Changes';
  const matchingChannel = story
    ? channelOptions.find(option => option.value === story.channel)
    : null;
  const initialChannel = matchingChannel || channelOptions[0];

  const [name, setName] = useState(story ? story.name : '');
  const [channel, setChannel] = useState(initialChannel);
  const [url, setUrl] = useState(story && story.url ? story.url : '');

  function getParams() {
    return {
      name,
      ...(action !== 'create' ? { edit_id: story.edit_id } : {}),
      channel: channel.value,
      url: url || null,
    };
  }

  const disabled = !name || !channel;

  return (
    <div className={`${action} story-modal`} onClick={() => setShowModal(false)}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="header">{headerTxt}</div>
        <div onClick={() => setShowModal(false)}>
          <Icon iconName="x" size={12} />
        </div>
        <div className="label">Post Name</div>
        <input
          value={name}
          onChange={e => setName(e.target.value)}
          placeholder="e.g. Best Holiday Finds"
        />
        <div className="dropdowns">
          <div>
            <div className="label">Channel</div>
            <BasicDropdown
              items={channelOptions}
              selectItem={idx => setChannel(channelOptions[idx])}
              dropdownLabel={channel.label}
            />
          </div>
        </div>
        <div className="label">Post URL</div>
        <input value={url} onChange={e => setUrl(e.target.value)} />
        <div className="optional">Optional</div>
        <hr></hr>
        <div className="controls">
          <button className="cancel" onClick={() => setShowModal(false)}>
            Cancel
          </button>
          <button
            className={`create ${disabled ? 'disabled' : ''}`}
            onClick={() => {
              handleSubmit(getParams());
              setShowModal(false);
            }}
            disabled={disabled}
          >
            {submitTxt}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StoryModal;
